<forma-card [appearance]="cardAppearance()" [style.--card-bg]="backgroundColor()">
  <div
    formaCardBody
    class="body"
    [class.has-inline-illustration]="illustration() && illustrationPlacement() === 'inline'">
    <div #textContent class="text-content">
      <div class="copy-content">
        @if (headingTpl() || bodyTpl()) {
          @if (headingTpl()) {
            <ng-container *ngTemplateOutlet="headingTpl()!.templateRef"></ng-container>
          } @else if (heading()) {
            <h1>{{ heading() }}</h1>
          }
          @if (bodyTpl()) {
            <ng-container *ngTemplateOutlet="bodyTpl()!.templateRef"></ng-container>
          } @else if (body()) {
            <p>{{ body() }}</p>
          }
        } @else if (heading() || body()) {
          @if (heading()) {
            <h1>{{ heading() }}</h1>
          }
          @if (body()) {
            <p>{{ body() }}</p>
          }
        } @else {
          <div [innerHTML]="htmlContent()"></div>
        }
      </div>

      @if (actionsTpl()) {
        <div class="actions-content">
          <ng-container *ngTemplateOutlet="actionsTpl()!.templateRef"></ng-container>
        </div>
      }
    </div>

    @if (asideTpl()) {
      <div class="aside-content">
        <ng-container *ngTemplateOutlet="asideTpl()!.templateRef"></ng-container>
      </div>
    }

    @if (iconTpl()) {
      <ng-container *ngTemplateOutlet="iconTpl()!.templateRef"></ng-container>
    } @else if (illustration()) {
      <div
        class="image-content illustration-content"
        [class.illustration-inline]="illustrationPlacement() === 'inline'">
        <forma-illustration
          [name]="illustration()!"
          [variant]="resolvedIllustrationConfig.variant"
          [colorScheme]="resolvedIllustrationConfig.colorScheme"
          [animation]="resolvedIllustrationConfig.animation"
          [animationIteration]="resolvedIllustrationConfig?.animationIteration ?? 1"
          [size]="resolvedIllustrationSize"
          [ariaHidden]="true" />
      </div>
    } @else if (imageSrc()) {
      <div class="image-content">
        <img [src]="imageSrc()" [alt]="imageAlt()" [style.max-height]="imageMaxHeight()" />
      </div>
    } @else if (iconName()) {
      <div class="image-content icon-content">
        <icon
          [name]="iconName()!"
          [size]="iconSize()"
          [color]="iconColor()"
          [style.height]="iconHeight()"
          [style.width]="iconWidth() ?? iconHeight()"
          aria-hidden="true" />
      </div>
    } @else {
      <div class="image-content">
        <ng-content></ng-content>
      </div>
    }
  </div>
</forma-card>
